// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3-mxo","row":"styles_row__1rTjc"};